export const MAIN_CLASS_NAME = 'agent-card';
export const DISABLED_CLASS_NAME = `${MAIN_CLASS_NAME}_disabled`;
export const EXTRA_CLASS_NAME = `${MAIN_CLASS_NAME}__extra`;
export const CONTENT_CLASS_NAME = `${MAIN_CLASS_NAME}__content`;
export const FOOTER_CLASS_NAME = `${MAIN_CLASS_NAME}__footer`;

export const TOOLSETS_PAGE_SIZE = 5;

export const TRANSLATION_GROUP_PREFIX = 'Agent: Card:';
